<template>
  <div class="file-upload-undo">
    File was successfully deleted
    <button type="button"
            class="btn-text btn-text--primary"
            @click="$emit('recover')">
      Undo?
    </button>
  </div>
</template>

<script>
export default {
  name: 'file-upload-undo',
}
</script>
